var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import flatpickr from 'flatpickr';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import WithRender from './DateTimePicker.html';
export const DATE_FORMAT_OPTIONS = {
    long: 'F j, Y',
    longDay: 'D, F j, Y',
    short: 'M j, Y',
    shortDay: 'D, M j, Y',
    simpleDMY: 'd-m-Y',
    simpleYMD: 'Y-m-d',
    simpleMDY: 'm-d-Y'
};
// TODO: More work is needed
// 1. Handling i18n/l10n
// 2. CSS customization
// 3. Support for multiple dates
// 4. Support for range dates
// 5. Watch min/max date and/or time.
let DateTimePicker = class DateTimePicker extends Vue {
    // TODO: More work is needed
    // 1. Handling i18n/l10n
    // 2. CSS customization
    // 3. Support for multiple dates
    // 4. Support for range dates
    // 5. Watch min/max date and/or time.
    constructor() {
        super(...arguments);
        this.open = false;
    }
    get classes() {
        return {
            'date-picker--active': this.open,
            'date-picker--error': this.error
        };
    }
    mounted() {
        let dateTimeFormat = '';
        if (this.showDate) {
            dateTimeFormat = this.format
                ? DATE_FORMAT_OPTIONS[this.format]
                : DATE_FORMAT_OPTIONS.simpleYMD;
        }
        if (this.showTime) {
            dateTimeFormat += this.militaryTime ? ' H:i' : ' h:i K';
        }
        const config = Object.assign({}, this.config, { minDate: this.minDate, maxDate: this.maxDate, minTime: this.minTime, maxTime: this.maxTime, noCalendar: !this.showDate, enableTime: this.showTime, time_24hr: this.militaryTime, dateFormat: dateTimeFormat.trim(), altInput: this.format.length > 0, altFormat: DATE_FORMAT_OPTIONS[this.format], wrap: this.withActionButtons });
        this.fp = this.flatPickerInstance(config);
        this.toggleInputAvailability();
        if (this.value) {
            this.fp.setDate(this.value);
        }
    }
    // Free up memory
    beforeDestroy() {
        this.fp.destroy();
    }
    valueChanged() {
        this.fp.setDate(this.value);
    }
    onMaxDateChanged() {
        this.fp.set({
            maxDate: this.maxDate
        });
    }
    onMinDateChanged() {
        this.fp.set({
            minDate: this.minDate
        });
    }
    onMaxTimeChanged() {
        this.fp.set({
            maxTime: this.maxTime
        });
    }
    onMinTimeChanged() {
        this.fp.set({
            minTime: this.minTime
        });
    }
    onDisableChanged() {
        this.toggleInputAvailability();
    }
    flatPickerInstance(config) {
        // Only Nitesh knows this
        const el = this.withActionButtons ? this.$el : this.$refs.datePickerInput;
        return flatpickr(el, Object.assign({}, config, { onValueUpdate: (selectedDates, dateStr, instance) => {
                // Emit single date instead of array.
                this.$emit('input', selectedDates[0], dateStr, instance);
            }, onOpen: (selectedDates, dateStr, instance) => {
                // Emit single date instead of array.
                this.open = true;
                this.$emit('open', selectedDates[0], dateStr, instance);
            }, onClose: () => {
                this.open = false;
            } }));
    }
    toggleInputAvailability() {
        const dateTimeInput = this.fp.altInput || this.fp.input;
        if (this.disabled) {
            dateTimeInput.setAttribute('disabled', 'true');
        }
        else {
            dateTimeInput.removeAttribute('disabled');
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Date)
], DateTimePicker.prototype, "value", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DateTimePicker.prototype, "error", void 0);
__decorate([
    Prop({ default: () => ({}) }),
    __metadata("design:type", Object)
], DateTimePicker.prototype, "config", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DateTimePicker.prototype, "withActionButtons", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], DateTimePicker.prototype, "format", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DateTimePicker.prototype, "militaryTime", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], DateTimePicker.prototype, "showDate", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], DateTimePicker.prototype, "showTime", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], DateTimePicker.prototype, "minTime", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], DateTimePicker.prototype, "maxTime", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Date)
], DateTimePicker.prototype, "minDate", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Date)
], DateTimePicker.prototype, "maxDate", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DateTimePicker.prototype, "clearAction", void 0);
__decorate([
    Prop({ default: 'Select date and time' }),
    __metadata("design:type", String)
], DateTimePicker.prototype, "placeholder", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DateTimePicker.prototype, "disabled", void 0);
__decorate([
    Watch('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DateTimePicker.prototype, "valueChanged", null);
__decorate([
    Watch('maxDate'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DateTimePicker.prototype, "onMaxDateChanged", null);
__decorate([
    Watch('minDate'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DateTimePicker.prototype, "onMinDateChanged", null);
__decorate([
    Watch('maxTime'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DateTimePicker.prototype, "onMaxTimeChanged", null);
__decorate([
    Watch('minTime'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DateTimePicker.prototype, "onMinTimeChanged", null);
__decorate([
    Watch('disabled'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DateTimePicker.prototype, "onDisableChanged", null);
DateTimePicker = __decorate([
    WithRender,
    Component({})
], DateTimePicker);
export default DateTimePicker;
//# sourceMappingURL=DateTimePicker.js.map